<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>
<script setup>
import { onMounted, onUnmounted, ref, reactive } from 'vue'
import { Head } from '@inertiajs/inertia-vue3'
import Brandcard from '@/Pages/Brand/Brandcard'
import usePref from '@/Shared/usePref.js'
import { useStore } from '@/store/bucket'
import Filter from './Filter'
import useFavorites from '@/Shared/useFavorites.js'
import useIsotope from '@/Shared/useIsotope.js'

const props = defineProps({
  brands: Array,
  category: String,
  pref: Object,
})

const containerRef = ref()
const filterRef = ref()

const state = reactive({
  categoryName: String,
  categoryNum: Number,
})

const favorite = reactive({
  all: [],
})

const categoryClass = (category) => {
  const temparray = category && category != '' ? category.split(',') : []
  let r = { 'category-all': true }
  temparray.forEach((item) => {
    r['category-' + item] = true
  })
  return r
}

const getCurrentCategory = () => {
  const param = location.search
  const category = !param ? 'all' : param.replace('?category=', '')
  return category
}

const setCurrentCategoryName = () => {
  if (getCurrentCategory() === 'all') {
    state.categoryName = 'ALL'
  } else {
    const result = props.pref.categories.find((item) => getCurrentCategory() === item['categorySlug'])
    state.categoryName = result.categoryName
  }
}

const setCurrentCategoryNum = () => {
  const items = document.querySelectorAll(`.category-${getCurrentCategory()}`)
  state.categoryNum = items.length
}

const callback = () => {
  setCurrentCategoryName()
  setCurrentCategoryNum()
}

const openFilter = () => {
  filterRef.value.toggleOpen()
}

onMounted(() => {
  usePref(props.pref)
  const store = useStore()
  store.updateBrandList(props.brands)

  const { sortFavoriteList } = useFavorites({ favorite: favorite, category: 'brand' })
  sortFavoriteList()

  useIsotope({
    isotopeContainer: containerRef.value,
    isotopeItem: '.isotope-item',
    data: favorite.all,
    key: 'brandThumb',
    category: props.category,
    callback: callback,
  })
})

onUnmounted(() => {})
</script>

<template>
  <div>
    <Head title="ブランド一覧" />

    <div class="main-contents bg-afgreen min-h-screen">
      <h2 class="page-title text-white">
        BRANDS
        <small>ブランド一覧</small>
      </h2>

      <div class="mt-[32px] sm:mt-[18px] px-[calc(5vw_+_10px)] xs:px-[40px] sm:px-[60px] lg:px-[40px] max-w-[600px] sm:max-w-[1000px] 2xl:max-w-[1280px] mx-auto">
        <div ref="containerRef" class="isotope-container m-[-2vw] xs:m-[-10px]">
          <button class="m-[2vw] xs:m-[10px] translate-y-[-42px] sm:translate-y-[-48px] font-rift font-bold text-[20px] xs:text-[22px] sm:text-[24px] pb-[16px] xs:pb-[20px] sm:pb-[24px] tracking-wide text-white relarive z-10" @click="openFilter">{{ state.categoryName }} : {{ state.categoryNum }} BRANDS</button>
          <div v-for="brand in favorite.all" :key="brand.brandID" class="isotope-item w-1/2 sm:w-1/3 lg:w-1/4 2xl:w-1/5 p-[2vw] xs:p-[10px] aspect-square" :class="categoryClass(brand.brandCategorySlug)">
            <Brandcard :info="brand" class="hover-item" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <teleport to="#app">
    <Filter ref="filterRef" :categories="props.pref.categories" />
  </teleport>
</template>
